import { useEffect } from 'react';

export function useTitle(title) {
  useEffect(() => {
    const oldTitle = document.title;
    var titleSet = false;

    if (title) {
      document.title = title;
      titleSet = true;
    }

    return () => titleSet && (document.title = oldTitle);
  });
}
